import * as React from 'react';
import { Grid, Box, IconButton, Button, Typography } from '@mui/material';
import { WeeklyGrossPayCard } from './WeeklyGrossPayCard';
import { WeeklyGroup } from '@AMIEWEB/NewOrder/types';
import { useWeeklyGrossPayStyles } from './weeklyGrossPayStyles';
import { useDispatch, useSelector } from 'react-redux';
import { selectOrderDetailsUIView, selectWeeklyGrossPayFetchError } from '@AMIEWEB/Order/Store/Order.selectors';
import { useTranslation } from 'react-i18next';
import { orderDataActions } from '@AMIEWEB/Order/Store/Order.redux';

export const WeeklyGrossPay: React.FC<{
  groups: WeeklyGroup[];
  setRereshEnaled: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ groups, setRereshEnaled }) => {
  const { classes } = useWeeklyGrossPayStyles();
  const orderDetailsUIView = useSelector(selectOrderDetailsUIView);
  const weeklyGrossPayFetchError = useSelector(selectWeeklyGrossPayFetchError);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let message: string | null = null;
  let refreshEnabled = true;

  if (weeklyGrossPayFetchError) {
    message = t('order.orderDetails.weeklyGrossPay.weeklyGrossPayFetchError');
  } else if (orderDetailsUIView?.orderDetails.positionsAvailable === 0) {
    message = t('order.orderDetails.weeklyGrossPay.noActivePositions');
    refreshEnabled = false;
  } else if (!groups?.length && orderDetailsUIView?.orderDetails.positionsAvailable > 0) {
    message = t('order.orderDetails.weeklyGrossPay.noData');
  }
  setRereshEnaled(refreshEnabled);

  if (message) {
    return (
      <Grid container direction="row" classes={{ root: classes.weeklyGrossPayContainer }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <Typography>{message}</Typography>
        </Box>
      </Grid>
    );
  }
  return (
    <Box className={classes.customContentClass}>
      <Grid container direction="row" classes={{ root: classes.weeklyGrossPayContainer }}>
        {groups.map((g, idx) => (
          <Grid
            item
            xs={12}
            key={`${g.specialtyId}-${g.subSpecialtyId}-${g.disciplineId}`}
            classes={{ root: classes.tableContainer }}
          >
            <Box sx={{ width: 1, minWidth: 0 }}>
              <WeeklyGrossPayCard group={g} idx={idx} count={groups.length} />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
